export enum IdTypes {
	id = 'ID',
	passport = 'PASSPORT',
}

export const idLabelsByType = {
  [IdTypes.id]: 'Cédula',
  [IdTypes.passport]: 'Pasaporte',
}
